import type { MessageValue, NoMessageValues } from 'react-intl'
import { defineMessages } from 'react-intl'

export const caseCardMessages = defineMessages<{
  readonly unassigned: NoMessageValues
  readonly updatedRelative: { readonly time: MessageValue }
}>({
  unassigned: {
    defaultMessage: 'Unassigned',
    description: 'case card — nobody is assigned to this case',
  },
  updatedRelative: {
    defaultMessage: 'Updated {time}',
    description: 'case card — relative time of the last update',
  },
})
